import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-money",
  "use": "icon-money-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-money\">\n  <path d=\"M160 192h704c70.7 0 128 57.3 128 128v480c0 70.7-57.3 128-128 128H160C89.3 928 32 870.7 32 800V320c0-70.7 57.3-128 128-128zm0 72c-30.9 0-56 25.1-56 56v480c0 30.9 25.1 56 56 56h704c30.9 0 56-25.1 56-56V320c0-30.9-25.1-56-56-56H160z\" />\n  <path d=\"M736 416h256v288H736c-79.5 0-144-64.5-144-144s64.5-144 144-144zm0 72c-39.8 0-72 32.2-72 72s32.2 72 72 72h184V488H736z\" />\n  <path d=\"M736 520a40 40 0 1 1 0 80 40 40 0 0 1 0-80z\" />\n  <path d=\"M248 376l104 128 104-128 56 45.5-89.2 109.8H480v64h-92v56h92v64h-92v76h-72v-76h-92v-64h92v-56h-92v-64h57.2L192 421.5 248 376z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/money.svg
// module id = ig9B
// module chunks = 43